export const STATUS_LOADING = 'loading';
export const STATUS_ERROR = 'error';
export const STATUS_SUCCESS = 'success';
